import {Component, OnInit, OnDestroy, ViewChild, Input, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import { debounceTime } from 'rxjs/operators';
import {LookupService} from "../../srvs/lookup";
import {UsageFilter} from "../../usage/usage.filter";
import {SettingsPersistenceService} from "../../services/settings-persistence.service";
import {TicketWorklogFilter} from "./ticket-worklog.filter";

@Component({
  selector: 'micro-ticket-worklog',
  templateUrl: './ticket-worklog.component.html'
})
export class TicketWorklogComponent implements OnInit, OnDestroy, OnChanges  {

  @Input()
  ticketId;

  @Input()
  refreshWorklog: boolean;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:TicketWorklogFilter = new TicketWorklogFilter();

  dateRangeSelector:UsageFilter = new UsageFilter();

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;

  get isEmbedded(): boolean {
    return !!this.ticketId;
  }

  constructor(private auth:AuthService,
              private env:EnvService,
              private http:HttpClient,
              public lookupService:LookupService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'refreshWorklog') {
        this.reload();
      }
    }
  }

  ngOnInit() {

    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.acc.ticket.worklog");
    this.pageSettings
      .setDateRangeSelector(this.dateRangeSelector) // if needed
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(this.isEmbedded)
      .setEmbeddedFilterProps({
        ticketId: this.ticketId,
        dateRange:{
          fromInfinite: true,
          untilInfinite: true,
          dateRangeUnit: "custom"
        }
      })
      .init();

    if (this.isEmbedded) {
      this.dateRangeSelector.fromInfinite = true;
      this.dateRangeSelector.untilInfinite = true;
      this.dateRangeSelector.dateRangeUnit = "custom";
    }

    this.dateRangeSelector.anyChange.pipe().pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
    // this.reload();
  }

  ngOnDestroy() {
  }

  public reload() {
    if (!this.paginator) return;

    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator?.pageIndex || 0))
      .set("size", '' + (this.paginator?.pageSize || this.pageSettings.defaultPageSize));

    if (!this.dateRangeSelector.fromInfinite) {
      params = params.set('from', '' + this.dateRangeSelector.from);
    }
    if (!this.dateRangeSelector.untilInfinite) {
      params = params.set('until', '' + this.dateRangeSelector.until);
    }

    this.http.get(`${this.env.e.url}/task/tickets/${this.ticketId}/worklog`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
  formatFeedback(feedback:string):string{
    return feedback
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
      .replace(/\n\r/g, '<br/>')
      .replace(/\n/g, '<br/>')
      .replace(/\r/g, '<br/>');
  }
}
